/*
 * Copyright Huesik (c) 2019.
 */



const cityPositionList = [
  { name: '강북구',  lat: 37.643416   , lng: 127.0112374  },
  { name: '강남구',  lat: 37.497654   , lng: 127.046795   },
  { name: '광진구',  lat: 37.545927   , lng: 127.086575   },
  { name: '강동구',  lat: 37.547053   , lng: 127.154992   },
  { name: '노원구',  lat: 37.655677   , lng: 127.070365   },
  { name: '강서구',  lat: 37.5655222 , lng: 126.8208219  },
  { name: '도봉구',  lat: 37.667089   , lng: 127.031649   },
  { name: '관악구',  lat: 37.474021   , lng: 126.944461   },
  { name: '동대문구', lat: 37.583224   , lng: 127.05236    },
  { name: '구로구',  lat: 37.496915   , lng: 126.885806   },
  { name: '마포구',  lat: 37.5588     , lng: 126.909762   },
  { name: '금천구',  lat: 37.465483   , lng: 126.902227   },
  { name: '서대문구', lat: 37.581167   , lng: 126.935317   },
  { name: '동작구',  lat: 37.498006   , lng: 126.930764   },
  { name: '성동구',  lat: 37.550952   , lng: 127.041232   },
  { name: '서초구',  lat: 37.47429     , lng: 127.006922  },
  { name: '성북구',  lat: 37.606199   , lng: 127.02766    },
  { name: '송파구',  lat: 37.502288   , lng: 127.098753   },
  { name: '은평구',  lat: 37.623202   , lng: 126.926009   },
  { name: '양천구',  lat: 37.520274   , lng: 126.856671   },
  { name: '종로구',  lat: 37.5941987 , lng: 126.9801843  },
  { name: '영등포구', lat: 37.517658   , lng: 126.910788   },
  { name: '용산구',  lat: 37.53052    , lng: 126.982926   },
  { name: '중구',   lat:  37.5553471 , lng:  126.9891209 },
  { name: '중랑구',  lat: 37.591341   , lng: 127.089261   },
  { name: '남구', lat: 35.1281530, lng: 129.0910790},
  { name: '금정구', lat: 35.2593970, lng: 129.0893810},
  { name: '서구', lat: 35.0951400, lng: 129.0191790},
  { name: '동구', lat: 35.1286550, lng: 129.0452510},
  { name: '연제구', lat: 35.1818340, lng: 129.0937240},
  { name: '북구', lat: 35.2351480, lng: 129.0216640},
  { name: '부산진구', lat: 35.1665930, lng: 129.0446060},
  { name: '사상구', lat: 35.1568760, lng: 128.9874600},
  { name: '중구', lat: 35.1064440, lng: 129.0307670},
  { name: '기장군', lat: 35.2435220, lng: 129.2229660},
  { name: '동래구', lat: 35.2041080, lng: 129.0795540},
  { name: '해운대구', lat: 35.1631600, lng: 129.1638520},
  { name: '사하구', lat: 35.0812790, lng: 128.9709290},
  { name: '영도구', lat: 35.0759730, lng: 129.0653990},
  { name: '수영구', lat: 35.159978 , lng: 129.114611},
  { name: '강서구', lat: 35.1481750, lng: 128.8774710},

  { name: '가평군', lat: 37.83154   , lng: 127.509883},
  { name: '고양시', lat: 37.65836   , lng: 126.83202},
  { name: '과천시', lat: 37.429246  , lng: 126.987445},
  { name: '광명시', lat: 37.478488  , lng: 126.864289},
  { name: '광주시', lat: 37.417141  , lng: 127.256141},
  { name: '구리시', lat: 37.594312  , lng: 127.129565},
  { name: '군포시', lat: 37.36167   , lng: 126.935174},
  { name: '김포시', lat: 37.615246  , lng: 126.715632},
  { name: '남양주시',lat: 37.636003  , lng: 127.216528},
  { name: '동두천시',lat: 37.903411  , lng: 127.060507},
  { name: '부천시', lat: 37.503414  , lng: 126.766031},
  { name: '성남시', lat: 37.444917  , lng: 127.138868},
  { name: '수원시', lat: 37.263573  , lng: 127.028601},
  { name: '시흥시', lat: 37.379888  , lng: 126.803103},
  { name: '안산시', lat: 37.321878  , lng: 126.830885},
  { name: '안성시', lat: 37.00797   , lng: 127.279679},
  { name: '안양시', lat: 37.394253  , lng: 126.956821},
  { name: '양주시', lat: 37.785288  , lng: 127.045845},
  { name: '양평군', lat: 37.49122   , lng: 127.487561},
  { name: '여주시', lat: 37.298024  , lng: 127.637163},
  { name: '연천군', lat: 38.096444  , lng: 127.074834},
  { name: '오산시', lat: 37.14981   , lng: 127.077221},
  { name: '용인시', lat: 37.241086  , lng: 127.177554},
  { name: '의왕시', lat: 37.344701  , lng: 126.96831},
  { name: '의정부시',lat: 37.738098  , lng: 127.033682},
  { name: '이천시', lat: 37.271995  , lng: 127.434822},
  { name: '파주시', lat: 37.759869  , lng: 126.780178},
  { name: '평택시', lat: 36.992108  , lng: 127.112945},
  { name: '포천시', lat: 37.894915  , lng: 127.200355},
  { name: '하남시', lat: 37.539265  , lng: 127.214892},
  { name: '화성시', lat: 37.199493  , lng: 126.831189},
]

export default cityPositionList
